import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableRateExceptions extends Layout {
    panelSecondaryFilters: Panel;
    sourceRateExceptions: DataSource;
    tableRateExceptions: Table;
}
